export default {"src":"/_next/static/media/female_1.2f3f8f92.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};